import { useQuery } from '@tanstack/react-query';
import { attendanceApi } from '../api/attendanceApi';
import { attendanceKeys } from './attendanceKeys';

export function useMonthlyCalendar(month: string | undefined) {
  return useQuery({
    queryKey: attendanceKeys.calendar(month),
    queryFn: () => attendanceApi.fetchMonthlyCalendar(month as string),
    enabled: !!month,
    staleTime: 60_000,
  });
}
